<template>
    <div class="col backgroundForm">
        <h3 clas="col" align="center">Reporte Movimiento de Embarcaciones</h3>

        <div class="form-row">
            <div class="form-group col offset-md-3 col-md-6">
                <label for="captain_download" class="badge badge-info">CAPITANIA</label>
                <transition name="fade" mode="out-in">
                <select v-if="dRolUser" name="captain_download" class="form-control" id="captain_download" v-model="port_select">
                    <option v-for="port in port_local" :value="port" :key="port.id">{{ port.name_port }}</option>
                </select>
                <div v-else class="alert alert-success">
                    {{ cDtsUser.name_port }}
                </div>
                </transition>
            </div>
        </div>

        <div class="form-row">
            <div class="form-group col-12 col-md-6">
                <label for="bandera_embarcacion" class="badge badge-primary">Fecha de Inicio</label>
                <input type="date" class="form-control" v-model="dReportDateIni" >
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="propulsion" class="badge badge-primary">Fecha Final</label>
                <input type="date" class="form-control" v-model="dReportDateEnd" >
            </div>
        </div>
        <div class="form-row">
            <button class="btn btn-outline-info col-12 col-md-3 offset-md-3" @click="mCallReport"><font-awesome-icon icon="file-pdf" />Reporte</button>
            <button class="btn btn-outline-info col-12 col-md-3" @click="mReportCharge"><font-awesome-icon icon="file-excel" />Reporte Excel</button>
        </div>

        <modal-loading :id-modal="dModalLoading" :title="dModalLoadingT" ></modal-loading>

        <modal-report :id-modal-report="modal_report" :title="modal_rep_title" :content="modal_rep_content" :url-r="url_report" :id-report="id_reporte" ></modal-report>
    </div>
</template>
<script>

import modalReport from '../modal/modalReport';
import ModalLoading from '../modal/modalLoading';
import Vue from 'vue'
import axios from 'axios'

export default {
    name:'report-ine',
    data(){
        return{
            dReportDateIni:null,
            dReportDateEnd:null,
            dModalLoading:'mReportIne',
            dModalLoadingT:'Solicitando',
            modal_report:'reprintDischarge',
            title:'Reporte INE excel',
            modal_rep_content:'Reporte INE',
            url_report:'excelIne',
            id_reporte:0,
            modal_rep_title:'Reporte Ine',
            port_select:{id:0},
            dRolUser:false,
            port_local:[]
        }
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        }
    },
    mounted(){
        this.mGetToday();
    },
    methods:{
        async mGetToday(){
            this.port_local=[];
            let  today = new Date();
            let m = today.getMonth() + 1;
            let mes = (m < 10) ? '0' + m : m;
            let d = today.getDate();
            let dia= (d < 10) ? '0'+d : d;
            this.dReportDateIni=today.getFullYear()+'-'+mes+'-'+dia;
            this.dReportDateEnd=today.getFullYear()+'-'+mes+'-'+dia;

            const ports = await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);        

            let aux_port_init={
                id:0,
                name_port:'TODOS LOS PUERTOS'
            }
            this.port_local=ports.data;
            this.port_local.push(aux_port_init);

            this.dRolUser= this.cDtsUser.role !== 4 ? true:false;
        },
        mCallReport(){
            if(this.cDtsUser.roleAssign === 'OPERADOR CAPITANIA'){
                this.port_select.id=this.cDtsUser.portId;
                this.port_select.name_port=this.cDtsUser.name_port;
            }
            console.log(this.port_select.id)
            if(this.port_select.id > 0){
                this.mProgressModal();
                axios.get('pdfIne/'+this.port_select.id+'/'+this.dReportDateIni+'/'+this.dReportDateEnd,
                    {
                        responseType:'blob'
                    })
                    .then(res => {
                        // console.log(res)
                        // const url = window.URL.createObjectURL(new Blob([res.data]));
                        

                        const url = window.URL.createObjectURL(new Blob([res.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'ReporteIne.pdf');
                        document.body.appendChild(link);
                        link.click();
                        setTimeout(()=>{
                                this.mCloseProgressModal();
                            }, 2000);
                    })
                    .catch(error => {
                        console.log(error);
                        setTimeout(()=>{
                                this.mCloseProgressModal();
                            }, 2000);
                    })
            }else{
                toastr.warning("Seleccione una capitania de puerto", "Advertencia");
            }
        },
        mReportCharge(){
            if(this.cDtsUser.roleAssign === 'OPERADOR CAPITANIA'){
                this.port_select.id=this.cDtsUser.portId;
                this.port_select.name_port=this.cDtsUser.name_port;
            }
            console.log(this.port_select.id)
            if(this.port_select.id >= 0){
                this.url_report=btoa('excelIne/'+this.port_select.id+'/'+this.dReportDateIni+'/'+this.dReportDateEnd);
                // let url_report=btoa(`${this.urlR}/${this.port_select.id }`);
                // let url_report=btoa(`pdfOrdopI/${id}`)
                let route = this.$router.resolve({path: `/report/${this.url_report}`});            
                window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
            }else{
                toastr.info(`Seleccione una opcion`, 'Error');
            }
        },
        mProgressModal(){
            $('#'+this.dModalLoading).modal('show');
        },
        mCloseProgressModal(){
            $('#'+this.dModalLoading).modal('hide');
        },
    },
    components:{
        'modal-loading':ModalLoading,
        'modal-report':modalReport
    }
}
</script>



// WEBPACK FOOTER //
// src/components/cotizacion/reportIne.vue